import React, { Fragment } from "react";
import Fade from "react-reveal/Fade";
import { Link } from "react-router-dom";

function Corporatemenu() {
  return (
    <Fragment>
      <div className="row aboutmenu">
        <div className="col-sm-12 button">
          <Fade top delay={1000}>
            <Link
              to="/corporateproduct/miscellaneous"
              onClick={() => {
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
              }}
            >
              <h3
                data-aos="fade-up"
                data-aos-duration="4000"
                data-aos-easing="ease-out-cubic"
              >
                Salaam Miscellaneous Takaful
              </h3>
            </Link>
          </Fade>

          <Fade right delay={1500}>
            <Link
              to="/corporateproduct/fire"
              onClick={() => {
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
              }}
            >
              <h3
                data-aos="fade-left"
                data-aos-duration="4000"
                data-aos-easing="ease-out-cubic"
              >
                Salaam Fire Takaful
              </h3>
            </Link>
          </Fade>

          <Fade left delay={2000}>
            <Link
              to="/corporateproduct/engineering"
              onClick={() => {
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
              }}
            >
              <h3
                data-aos="fade-right"
                data-aos-duration="4000"
                data-aos-easing="ease-out-cubic"
              >
                Salaam Engineering Takaful
              </h3>
            </Link>
          </Fade>

          <Fade left delay={2500}>
            <Link
              to="/corporateproduct/healthgroup"
              onClick={() => {
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
              }}
            >
              <h3
                data-aos="fade-right"
                data-aos-duration="4000"
                data-aos-easing="ease-out-cubic"
              >
                Salaam Group Health Takaful
              </h3>
            </Link>
          </Fade>
        </div>
      </div>
    </Fragment>
  );
}

export default Corporatemenu;
